module.exports = __webpack_public_path__ + "static/media/maria.13289343.png";